import {Client, ClientUser, Workspace} from '../../../API';
import {User} from '../../../utils/typescript/interfaces';

// Single fixed demo tenant/user — the whole point of mock mode is "no auth,
// no network," so there is exactly one persona, not a login flow.
export const TENANT_ID = 'mock-client-1';
export const USER_SUB = 'mock-sub-1';
export const CLIENT_USER_ID = 'mock-user-1';
export const WORKSPACE_ID = 'mock-ws-1';
export const CLIENT_SLUG = 'acme';
export const WORKSPACE_SLUG = 'main';

const NOW = new Date('2026-01-01T00:00:00.000Z').toISOString();

export const mockAuthUser: User = {
    sub: USER_SUB,
    name: 'Demo',
    family_name: 'User',
    email: 'demo@logycore.app',
    'custom:clientId': TENANT_ID,
};

export const mockClient: Client = {
    __typename: 'Client',
    id: TENANT_ID,
    createdAt: NOW,
    created_at: NOW,
    customer_id: null,
    defaultWorkspaces: JSON.stringify([WORKSPACE_ID]),
    deletedAt: null,
    inviteLink: null,
    meta: JSON.stringify({quizzesCount: 0, itemsCount: 0, aiUsageCount: 0}),
    name: 'Acme',
    ownerUserId: CLIENT_USER_ID,
    slug: CLIENT_SLUG,
    subscription_details: JSON.stringify({}),
    subscription_endsAt: null,
    subscription_plan: 'free',
    subscription_status: 'active',
    updatedAt: NOW,
    userRole: 'owner',
    version: 1,
    // `audit` on: it's the feature this mock tenant exists to demo (see studio/demo.html,
    // which lands on PAGES.AUDITS). `finance` stays off — its UI is fake/hardcoded behind
    // the flag, not implemented, so it'd misrepresent the product if shown here.
    feature_flags: JSON.stringify({audit: true}),
};

export const mockClientUser: ClientUser = {
    __typename: 'ClientUser',
    id: CLIENT_USER_ID,
    avatarPath: null,
    closedAt: null,
    createdAt: NOW,
    deletedAt: null,
    email: mockAuthUser.email,
    isAdmin: true,
    isConfirmed: true,
    isReadOnly: false,
    lastActive: NOW,
    name: mockAuthUser.name,
    ownerId: TENANT_ID,
    roleUpdatedBy: null,
    roles: '{}',
    sub: USER_SUB,
    surname: mockAuthUser.family_name,
    updatedAt: NOW,
    version: 1,
};

export const mockWorkspace: Workspace = {
    __typename: 'Workspace',
    archivedIds: '[]',
    avatarPath: null,
    childIds: '[]',
    createdAt: NOW,
    deletedAt: null,
    id: WORKSPACE_ID,
    name: 'Main',
    ownerId: TENANT_ID,
    pinnedIds: '[]',
    slug: WORKSPACE_SLUG,
    trashedIds: '[]',
    updatedAt: NOW,
    version: 1,
};
